import React,{Component} from 'react'

class Radar extends Component{
  constructor(props){
    super(props)
    this.warnName=  this.props.affiliate == 'kotv' ? 'WARN Radar' : 'ESP Radar';
    this.warningPage = this.props.affiliate == 'kotv' ? '/weatheralerts' : '/weatheralerts';
    this.warnLink = this.props.affiliate == 'kotv' ? '/warn-interactive-live-radar' : '/esp-radar';
    this.streetLink = this.props.affiliate == 'kotv' ? '/u-control-weather-center' : '/u-control-weather-center';
  }
  render(){
    return(
      <div className='radars'>
        <h3>Radars</h3>
        <div className='radar-inner'>
          <img src='https://radar.kotv.com/kotv/comp/600x330/statewide_anim.gif' />
          <div className='row'>
            <div className='col-xs-6 text-center'>
              <a href={this.warnLink} target='_blank'><button className="warn-radar" type='button'>{this.warnName}</button></a>
            </div>
            <div className='col-xs-6 text-center'>
              <a href={this.streetLink} target='_blank'><button id='streetRadar' type='button'>Street Level Radar</button></a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Radar;



// WEBPACK FOOTER //
// ./app/components/custom/ssr/WeatherTakeover/Radar.js